import { useState, useEffect } from 'react';
import { collection, getDocs, query, where, limit } from 'firebase/firestore';
import { db } from '../firebase';

export const useDocumentBySlug = <T extends { id: string }>(collectionName: string, slug: string | undefined) => {
    const [document, setDocument] = useState<T | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (!slug) {
            setIsLoading(false);
            return;
        }

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const q = query(
                    collection(db, collectionName),
                    where('slug', '==', slug),
                    limit(1)
                );

                const snapshot = await getDocs(q);
                if (!snapshot.empty) {
                    const doc = snapshot.docs[0];
                    setDocument({ id: doc.id, ...doc.data() } as T);
                } else {
                    setDocument(null);
                }
            } catch (err) {
                setError(err as Error);
                console.error(`Error fetching document with slug ${slug} from ${collectionName}:`, err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [collectionName, slug]);

    return { document, isLoading, error };
};
